import { decimalToHex } from './';

export const convertRGBToHex = color =>
  `#${decimalToHex(color.values[0])}${decimalToHex(color.values[1])}${decimalToHex(color.values[2])}`;
